import { PluginKey } from '@atlaskit/editor-prosemirror/state';

import type { InEditorUserContentDecorationPluginState } from './in-editor-user-content-decoration-plugin';

export const inEditorUserContentDecorationPluginKey =
	new PluginKey<InEditorUserContentDecorationPluginState>('inEditorUserContentDecorationPlugin');
